import { render, staticRenderFns } from "./homeSvg.vue?vue&type=template&id=ed7985b8&"
import script from "./homeSvg.vue?vue&type=script&lang=js&"
export * from "./homeSvg.vue?vue&type=script&lang=js&"
import style0 from "./homeSvg.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports